import React from 'react';
import { Phone, CheckCircle, DollarSign, Info, Shield } from 'lucide-react';
export function DotForLifePage() {
  return <div className="min-h-screen bg-gray-50" data-id="element-5108">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white py-16" data-id="element-5109">
        <div className="container mx-auto px-4" data-id="element-5110">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center" data-id="element-5111">
            DOT For Life Program
          </h1>
          <p className="text-xl text-gray-100 text-center" data-id="element-5112">
            Complete DOT Compliance & Inspection Service
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12" data-id="element-5113">
        <div className="max-w-4xl mx-auto" data-id="element-5114">
          {/* Commercial Motor Vehicle Definition */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-5115">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center" data-id="element-5116">
              <Info className="mr-3 text-blue-600" size={28} data-id="element-5117" />
              What is a Commercial Motor Vehicle?
            </h2>

            <p className="text-lg text-gray-700 mb-6" data-id="element-5118">
              You are operating a commercial motor vehicle if you transport
              passengers or property in a vehicle that:
            </p>

            <div className="space-y-6" data-id="element-5119">
              {/* Actual Weight */}
              <div className="bg-blue-50 border-l-4 border-blue-500 p-6" data-id="element-5120">
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-5121">
                  Has an actual gross vehicle weight (GVW) or gross combination
                  vehicle weight (GCW) of 10,001 pounds or more
                </h3>
                <div className="space-y-2 ml-4" data-id="element-5122">
                  <div className="flex items-start" data-id="element-5123">
                    <span className="mr-2" data-id="element-5124">•</span>
                    <p className="text-gray-700" data-id="element-5125">
                      <strong data-id="element-5126">GVW</strong> means the weight of a vehicle and its
                      load
                    </p>
                  </div>
                  <div className="flex items-start" data-id="element-5127">
                    <span className="mr-2" data-id="element-5128">•</span>
                    <p className="text-gray-700" data-id="element-5129">
                      <strong data-id="element-5130">GCW</strong> means the weight of a combination
                      vehicle and its load
                    </p>
                  </div>
                </div>
              </div>

              {/* Rated Weight */}
              <div className="bg-green-50 border-l-4 border-green-500 p-6" data-id="element-5131">
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-5132">
                  Has a gross vehicle weight rating (GVWR) or gross combination
                  weight rating (GCWR) of 10,001 pounds or more
                </h3>
                <div className="space-y-2 ml-4" data-id="element-5133">
                  <div className="flex items-start" data-id="element-5134">
                    <span className="mr-2" data-id="element-5135">•</span>
                    <p className="text-gray-700" data-id="element-5136">
                      <strong data-id="element-5137">GVWR</strong> is the value specified by the
                      manufacturer as a safe loaded weight of a single vehicle
                      (the GVWR is located on the manufacturer's tag, usually
                      found inside the driver's side door)
                    </p>
                  </div>
                  <div className="flex items-start" data-id="element-5138">
                    <span className="mr-2" data-id="element-5139">•</span>
                    <p className="text-gray-700" data-id="element-5140">
                      <strong data-id="element-5141">GCWR</strong> is the value specified by the
                      manufacturer as the loaded weight of a combination of
                      vehicles
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Here's How it Works */}
          <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white rounded-lg shadow-xl p-8 mb-8" data-id="element-5142">
            <h2 className="text-3xl font-bold mb-6 text-center" data-id="element-5143">
              Here's How it Works
            </h2>

            <div className="bg-white text-gray-900 rounded-lg p-6 mb-6 text-center" data-id="element-5144">
              <p className="text-2xl font-bold mb-2 flex items-center justify-center" data-id="element-5145">
                <DollarSign className="text-green-600" size={32} data-id="element-5146" />
                Sign up fee for each Truck is $225.00
              </p>
            </div>

            <div className="space-y-4" data-id="element-5147">
              <div className="bg-white/10 rounded-lg p-4 flex items-start" data-id="element-5148">
                <span className="text-2xl font-bold mr-4 flex-shrink-0" data-id="element-5149">
                  1.
                </span>
                <div data-id="element-5150">
                  <p className="text-lg font-semibold" data-id="element-5151">
                    We will do your DOT inspection Yearly for Free
                  </p>
                  <p className="text-gray-200" data-id="element-5152">$99.00 Value</p>
                </div>
              </div>

              <div className="bg-white/10 rounded-lg p-4 flex items-start" data-id="element-5153">
                <span className="text-2xl font-bold mr-4 flex-shrink-0" data-id="element-5154">
                  2.
                </span>
                <p className="text-lg" data-id="element-5155">
                  Pick up your Truck when its due for inspection
                </p>
              </div>

              <div className="bg-white/10 rounded-lg p-4 flex items-start" data-id="element-5156">
                <span className="text-2xl font-bold mr-4 flex-shrink-0" data-id="element-5157">
                  3.
                </span>
                <p className="text-lg" data-id="element-5158">
                  Free fluid top off Between oil changes (Fuel excluded)
                </p>
              </div>

              <div className="bg-white/10 rounded-lg p-4 flex items-start" data-id="element-5159">
                <span className="text-2xl font-bold mr-4 flex-shrink-0" data-id="element-5160">
                  4.
                </span>
                <p className="text-lg font-semibold" data-id="element-5161">
                  DOT COMPLIANCE MANAGEMENT
                </p>
              </div>

              <div className="bg-white/10 rounded-lg p-4 flex items-start" data-id="element-5162">
                <span className="text-2xl font-bold mr-4 flex-shrink-0" data-id="element-5163">
                  5.
                </span>
                <p className="text-lg" data-id="element-5164">
                  Help explaining tickets and ticket avoidance
                </p>
              </div>

              <div className="bg-white/10 rounded-lg p-4 flex items-start" data-id="element-5165">
                <span className="text-2xl font-bold mr-4 flex-shrink-0" data-id="element-5166">
                  6.
                </span>
                <p className="text-lg" data-id="element-5167">
                  Keep you up to date on DOT Law changes
                </p>
              </div>

              <div className="bg-white/10 rounded-lg p-4 flex items-start" data-id="element-5168">
                <span className="text-2xl font-bold mr-4 flex-shrink-0" data-id="element-5169">
                  7.
                </span>
                <p className="text-lg" data-id="element-5170">Monthly Light inspection</p>
              </div>
            </div>

            <div className="bg-yellow-50 text-gray-900 rounded-lg p-6 mt-6 text-center" data-id="element-5171">
              <p className="text-lg font-semibold" data-id="element-5172">
                By Following our recommendations you will greatly reduce your
                yearly ticket cost.
              </p>
            </div>
          </div>

          {/* Pricing */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8 text-center" data-id="element-5173">
            <h2 className="text-3xl font-bold text-gray-900 mb-4 flex items-center justify-center" data-id="element-5174">
              <Shield className="mr-3 text-[#B1050B]" size={32} data-id="element-5175" />
              Program Pricing
            </h2>
            <div className="bg-green-50 border-2 border-green-500 rounded-lg p-8 inline-block" data-id="element-5176">
              <p className="text-lg text-gray-700 mb-2" data-id="element-5177">Regular Price</p>
              <p className="text-5xl font-bold text-[#B1050B]" data-id="element-5178">$225.00</p>
              <p className="text-gray-600 mt-2" data-id="element-5179">per truck, per year</p>
            </div>
          </div>

          {/* Program Benefits Summary */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-5180">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center" data-id="element-5181">
              What's Included
            </h2>

            <div className="grid md:grid-cols-2 gap-4" data-id="element-5182">
              <div className="flex items-start bg-blue-50 rounded p-4" data-id="element-5183">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-5184" />
                <div data-id="element-5185">
                  <p className="font-semibold text-gray-900" data-id="element-5186">
                    Free Yearly DOT Inspection
                  </p>
                  <p className="text-sm text-gray-600" data-id="element-5187">$99 value included</p>
                </div>
              </div>

              <div className="flex items-start bg-blue-50 rounded p-4" data-id="element-5188">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-5189" />
                <div data-id="element-5190">
                  <p className="font-semibold text-gray-900" data-id="element-5191">
                    Inspection Pickup Service
                  </p>
                  <p className="text-sm text-gray-600" data-id="element-5192">We come to you</p>
                </div>
              </div>

              <div className="flex items-start bg-blue-50 rounded p-4" data-id="element-5193">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-5194" />
                <div data-id="element-5195">
                  <p className="font-semibold text-gray-900" data-id="element-5196">
                    Free Fluid Top-Offs
                  </p>
                  <p className="text-sm text-gray-600" data-id="element-5197">
                    Between oil changes (fuel excluded)
                  </p>
                </div>
              </div>

              <div className="flex items-start bg-blue-50 rounded p-4" data-id="element-5198">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-5199" />
                <div data-id="element-5200">
                  <p className="font-semibold text-gray-900" data-id="element-5201">
                    DOT Compliance Management
                  </p>
                  <p className="text-sm text-gray-600" data-id="element-5202">
                    Stay compliant year-round
                  </p>
                </div>
              </div>

              <div className="flex items-start bg-blue-50 rounded p-4" data-id="element-5203">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-5204" />
                <div data-id="element-5205">
                  <p className="font-semibold text-gray-900" data-id="element-5206">
                    Ticket Help & Avoidance
                  </p>
                  <p className="text-sm text-gray-600" data-id="element-5207">
                    Expert guidance and support
                  </p>
                </div>
              </div>

              <div className="flex items-start bg-blue-50 rounded p-4" data-id="element-5208">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-5209" />
                <div data-id="element-5210">
                  <p className="font-semibold text-gray-900" data-id="element-5211">DOT Law Updates</p>
                  <p className="text-sm text-gray-600" data-id="element-5212">
                    Stay informed on changes
                  </p>
                </div>
              </div>

              <div className="flex items-start bg-blue-50 rounded p-4" data-id="element-5213">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-5214" />
                <div data-id="element-5215">
                  <p className="font-semibold text-gray-900" data-id="element-5216">
                    Monthly Light Inspection
                  </p>
                  <p className="text-sm text-gray-600" data-id="element-5217">Regular safety checks</p>
                </div>
              </div>
            </div>
          </div>

          {/* Simple Rules */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-5218">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center" data-id="element-5219">
              Simple Rules
            </h2>

            <div className="space-y-4" data-id="element-5220">
              <div className="bg-yellow-50 border-l-4 border-yellow-500 p-4" data-id="element-5221">
                <p className="text-gray-800" data-id="element-5222">
                  <strong data-id="element-5223">One membership per truck</strong> - You will need to
                  buy one membership per truck
                </p>
              </div>

              <div className="bg-blue-50 border-l-4 border-blue-500 p-4" data-id="element-5224">
                <p className="text-gray-800" data-id="element-5225">
                  <strong data-id="element-5226">Repairs extra</strong> - Repair costs are not included
                  in membership
                </p>
              </div>

              <div className="bg-green-50 border-l-4 border-green-500 p-4" data-id="element-5227">
                <p className="text-gray-800" data-id="element-5228">
                  <strong data-id="element-5229">Transferable</strong> - Membership is transferable
                  from old truck to replacement truck
                </p>
              </div>
            </div>
          </div>

          {/* Value Proposition */}
          <div className="bg-gradient-to-r from-green-600 to-green-700 text-white rounded-lg shadow-xl p-8 mb-8 text-center" data-id="element-5230">
            <h2 className="text-3xl font-bold mb-4" data-id="element-5231">
              Save Money & Stay Compliant
            </h2>
            <p className="text-xl mb-2" data-id="element-5232">
              By following our recommendations, you will greatly reduce your
              yearly ticket cost.
            </p>
            <p className="text-lg text-green-100" data-id="element-5233">
              One membership covers everything you need for DOT compliance
            </p>
          </div>

          {/* CTA Section */}
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 text-white rounded-lg shadow-xl p-8 text-center" data-id="element-5234">
            <h2 className="text-3xl font-bold mb-4" data-id="element-5235">
              Join the DOT For Life Program Today
            </h2>
            <p className="text-xl mb-6" data-id="element-5236">
              Complete DOT compliance and inspection service for just $225/year
              per truck
            </p>
            <a href="tel:2484788382" className="inline-flex items-center bg-[#B1050B] hover:bg-[#8A0408] text-white px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-lg" data-id="element-5237">
              <Phone className="mr-3" size={24} data-id="element-5238" />
              Call (248) 478-8382 to Sign Up
            </a>
            <p className="mt-4 text-gray-300" data-id="element-5239">
              24175 Industrial Park Dr., Farmington Hills, MI 48335
            </p>
          </div>
        </div>
      </div>
    </div>;
}